// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { BenchmarkOverrideFromJSON, BenchmarkOverrideToJSON, ClimateScenarioFromJSON, ClimateScenarioToJSON, DatapointFormulaFromJSON, DatapointFormulaToJSON, DatapointIdFromJSON, DatapointIdToJSON, TenorFromJSON, TenorToJSON, } from './';
export function DatapointContextFromJSON(json) {
    return {
        'projectedOnly': !exists(json, 'projectedOnly') ? undefined : json['projectedOnly'],
        'objective': !exists(json, 'objective') ? undefined : json['objective'],
        'cffModelId': !exists(json, 'cffModelId') ? undefined : json['cffModelId'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'climateScenario': !exists(json, 'climateScenario') ? undefined : ClimateScenarioFromJSON(json['climateScenario']),
        'insightDatapoint': !exists(json, 'insightDatapoint') ? undefined : DatapointIdFromJSON(json['insightDatapoint']),
        'formula': !exists(json, 'formula') ? undefined : DatapointFormulaFromJSON(json['formula']),
        'tenor': !exists(json, 'tenor') ? undefined : TenorFromJSON(json['tenor']),
        'benchmarkOverride': !exists(json, 'benchmarkOverride') ? undefined : BenchmarkOverrideFromJSON(json['benchmarkOverride']),
    };
}
export function DatapointContextToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'projectedOnly': value.projectedOnly,
        'objective': value.objective,
        'cffModelId': value.cffModelId,
        'format': value.format,
        'climateScenario': ClimateScenarioToJSON(value.climateScenario),
        'insightDatapoint': DatapointIdToJSON(value.insightDatapoint),
        'formula': DatapointFormulaToJSON(value.formula),
        'tenor': TenorToJSON(value.tenor),
        'benchmarkOverride': BenchmarkOverrideToJSON(value.benchmarkOverride),
    };
}
